/* globals gtag*/
import React, { useEffect, useState, useMemo, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import {
  /* SetMasterCategories,SetDefaultMasterCategories,SetUrlPrefix,SetImgPrefix,SetDefaultCategories,SetSearchUrl, */ SetShowFilters,
  SetSort,
  SetConfig,
  SetIsMobile,
  SetWordsHistory,
  SetAdvancedCustomization,
  SetSeoSettings,
} from "./state/actions/index"
import Header from "./components/Header/Header"
import SearchBar from "./components/SearchBar/SearchBar"
import ResultsContainer from "./components/ResultsContainer/ResultsContainer"
import FiltersContainer from "./components/FiltersContainer/FiltersContainer"
// import CategoriesContainer from "./components/CategoriesContainer/CategoriesContainer";
// import ProductsRaccomandations from "./components/ProductsRaccomandations/ProductsRaccomandations";
// import CategoriesRaccomandations from "./components/CategoriesRaccomandations/CategoriesRaccomandations";
// import WordsHistory from "./components/WordsHistory/WordsHistory";
import ActiveFiltersContainer from "./components/ActiveFiltersContainer/ActiveFiltersContainer"
import SuggestedWords from "./components/SuggestedWords/SuggestedWords"
import FiltersButton from "./components/FiltersButton/FiltersButton"
import NoProducts from "./components/NoProducts/NoProducts"
import Alert from "./components/Alert/Alert"
import Utils from "./utils/Utils"
import VoiceRecognition from "./components/VoiceRecognition/VoiceRecognition"
import axios from "axios"
import BarcodeReader from "./components/BarcodeReader/BarcodeReader"
import Cookies from "universal-cookie"
// import PerfectScrollbar from 'react-perfect-scrollbar';
import $ from "jquery"
import Showcase from "./components/Showcase/Showcase"
import { FocusScope } from "react-aria"

const App = () => {
  const listingBanner = useSelector((state) => state.listingBanner)
  const searchWord = useSelector((state) => state.searchWord)
  const showFilters = useSelector((state) => state.showFilters)
  const activeFilters = useSelector((state) => state.activeFilters)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const isSearching = useSelector((state) => state.isSearching)
  const suggestedWords = useSelector((state) => state.suggestedWords)
  const wordsHistory = useSelector((state) => state.wordsHistory)
  const isAutocompleteOpen = useSelector((state) => state.isAutocompleteOpen)
  const queryOptions = useSelector((state) => state.config.queryOptions)
  // const promotionsFirstScreen = useSelector(state => state.config.promotions.firstScreen);
  // const promotionsListing = useSelector(state => state.config.promotions.listing);
  const alertConfig = useSelector((state) => state.config.alert)
  const shopId = useSelector((state) => state.config.shopId)
  const display = useSelector((state) => state.config.display)
  const ga4 = useSelector((state) => state.config.ga4)
  const show = useSelector((state) => state.config.show)
  const priceGroup = useSelector((state) => state.config.priceGroup)
  const accentColor = useSelector((state) => state.config.accentColor)
  const voiceSearch = useSelector((state) => state.config.voiceSearch)
  const autocomplete = useSelector((state) => state.config.autocomplete)
  const triggers = useSelector((state) => state.config.triggers)
  const categoryTiles = useSelector(
    (state) => state.config.triggers.categoryTiles
  )
  const raccomandationsCategories = useSelector(
    (state) => state.config.triggers.raccomandationsCategories
  )
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const resultsCount = useSelector((state) => state.resultsCount)
  const nameProducts = useSelector(
    (state) => state.config.placeholders.products
  )
  const nameShow = useSelector((state) => state.config.placeholders.show)
  const [mounted, setMounted] = useState(false)
  const seoSettings = useSelector((state) => state.config.seoSettings)
  // var reactivePromotionsListing=useMemo(()=>isMobile?promotionsListing.mobile:(promotionsListing.desktop),[isMobile,promotionsListing]);
  const reactivePromotionsListing = useMemo(
    () => (isMobile ? listingBanner?.mobileImageUrl : listingBanner?.imageUrl),
    [isMobile, listingBanner]
  )
  const minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  )
  const cookies = new Cookies()
  const dispatch = useDispatch()
  const [subCategory, setSubCategory] = useState(null)
  const hideFilters = useCallback(() => {
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_close_filters")
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({ event: "as_close_filters", data: {} })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_close_filters", {})
      }
    }
    dispatch(SetShowFilters(false))
  }, [dispatch, shopId, baseUrl])

  const showStyle = {
    border: "solid 1px " + accentColor,
    backgroundColor: accentColor + "26",
  }

  const onResize = useCallback(
    (config, isFirstTime = false) => {
      dispatch(SetIsMobile(window.innerWidth <= 768))
      let tempWebsiteSearchButtons = null
      let tempWebsiteSearchButtonsMobile = null
      let tempWebsiteSearchButton = null
      let tempWebsiteSearchButtonMobile = null
      if (config.show.id.desktop === "") {
        tempWebsiteSearchButtons = $(
          document.getElementsByName(config.show.name.desktop)
        )
        tempWebsiteSearchButtonsMobile = $(
          document.getElementsByName(config.show.name.mobile)
        )
      } else {
        tempWebsiteSearchButton = $("#" + config.show.id.desktop)
        tempWebsiteSearchButtonMobile = $("#" + config.show.id.mobile)
      }
      if (Utils.isOpenedLayer()) {
        Utils.riSetSearchbarPosition(window.innerWidth <= 768)
        Utils.closeLayer(config.display, window.innerWidth <= 768)
        Utils.openLayer(
          config.display,
          config.show.type,
          window.innerWidth <= 768,
          false
        )
      }

      if (config.show.type === "click" || window.innerWidth <= 768) {
        for (const el of tempWebsiteSearchButtonsMobile || []) {
          $(el).on("click focus", (event) => {
            event.preventDefault()
            Utils.openLayer(
              config.display,
              config.show.type,
              window.innerWidth <= 768,
              true
            )
            const customEvent = new CustomEvent("as-open-layer")
            document.body.dispatchEvent(customEvent)
            Utils.sendAnalyticsObject(config.baseUrl, config.shopId, "as_open")
            sessionStorage.setItem("isLayerOpen", "true")
            if (!!config?.ga4?.isActive) {
              if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
                window.dataLayer.push({ event: "as_open", data: {} })
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_open", {})
              }
            }
          })
        }

        if (tempWebsiteSearchButtonMobile) {
          tempWebsiteSearchButtonMobile.on("click focus", (event) => {
            event.preventDefault()
            Utils.openLayer(
              config.display,
              config.show.type,
              window.innerWidth <= 768,
              true
            )
            const customEvent = new CustomEvent("as-open-layer")
            document.body.dispatchEvent(customEvent)
            Utils.sendAnalyticsObject(config.baseUrl, config.shopId, "as_open")
            sessionStorage.setItem("isLayerOpen", "true")
            if (!!config?.ga4?.isActive) {
              if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
                window.dataLayer.push({event: "as_open", data: {}})
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_open", {})
              }
            }
          })
        }

        for (const el of tempWebsiteSearchButtons || []) {
          $(el).on("click focus", (event) => {
            event.preventDefault()
            Utils.openLayer(
              config.display,
              config.show.type,
              window.innerWidth <= 768,
              true
            )
            Utils.sendAnalyticsObject(config.baseUrl, config.shopId, "as_open")
            sessionStorage.setItem("isLayerOpen", "true")
            const customEvent = new CustomEvent("as-open-layer")
            document.body.dispatchEvent(customEvent)
            if (!!config?.ga4?.isActive) {
              if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
                window.dataLayer.push({event: "as_open", data: {}})
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_open", {})
              }
            }
          })
        }

        if (tempWebsiteSearchButton) {
          tempWebsiteSearchButton.on("click focus", (event) => {
            event.preventDefault()
            Utils.openLayer(
              config.display,
              config.show.type,
              window.innerWidth <= 768,
              true
            )
            Utils.sendAnalyticsObject(config.baseUrl, config.shopId, "as_open")
            sessionStorage.setItem("isLayerOpen", "true")
            const customEvent = new CustomEvent("as-open-layer")
            document.body.dispatchEvent(customEvent)
            if (!!config?.ga4?.isActive) {
              if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
                window.dataLayer.push({event: "as_open", data: {}})
              } else if (typeof gtag !== "undefined") {
                gtag("event", "as_open", {})
              }
            }
          })
        }
        // if (config.show.id.desktop !== config.show.id.mobile)
        //   tempWebsiteSearchButton.on("click focus", (event) => {
        //     event.preventDefault();
        //     Utils.openLayer(
        //       config.display,
        //       config.show.type,
        //       window.innerWidth <= 768,
        //       true
        //     );
        //
        //   });
        Utils.setLayerPosition(0, 0)
        if (config.display === "half-screen") {
          Utils.setPosition("accelasearch-searchbar", {
            right: "unset",
            left: 40,
          })
          Utils.setPosition("as-autocomplete", {
            top: "unset",
            right: "unset",
          })
        } else if (
          config.display === "full-screen" &&
          !(window.innerWidth <= 768)
        )
          Utils.setPosition("accelasearch-searchbar", { left: "50%" })
      } else if (config.display === "windowed") {
        if (tempWebsiteSearchButton.offset().left < window.innerWidth / 3)
          Utils.setLayerPosition(
            tempWebsiteSearchButton.offset().top + 40,
            tempWebsiteSearchButton.offset().left
          )
        else if (
          tempWebsiteSearchButton.offset().left +
            tempWebsiteSearchButton.width() >
          (window.innerWidth * 2) / 3
        )
          Utils.setLayerPosition(
            tempWebsiteSearchButton.offset().top + 40,
            (window.innerWidth -
              (tempWebsiteSearchButton.offset().left +
                tempWebsiteSearchButton.width())) /
              2,
            "right"
          )
        else
          Utils.setLayerPosition(
            tempWebsiteSearchButton.offset().top + 40,
            tempWebsiteSearchButton.offset().left -
              tempWebsiteSearchButton.width() / 2
          )
      } else if (config.display === "half-screen" && !window.innerWidth <= 768)
        Utils.setLayerPosition(0, "50%")
      else Utils.setLayerPosition(0, 0)
    },
    [dispatch]
  )

  useEffect(() => {
    dispatch(SetIsMobile(window.innerWidth <= 768))
    dispatch(SetAdvancedCustomization(window.AS_ADVANCED_CONFIG))
    let config = window.AS_CONFIG_DATA
    if (!mounted) {
      dispatch(SetConfig(config))
      Utils.sendAnalyticsObject(config.baseUrl, config.shopId, "as_init")

      if (!!config?.ga4?.isActive) {
        if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
          window.dataLayer.push({ event: "as_init", data: {} })
        } else if (typeof gtag !== "undefined") {
          gtag("event", "as_init", {})
        }
      }
      dispatch(SetWordsHistory(cookies.get("ASWordsHistory")))
      window.addEventListener("resize", () => {
        onResize(config)
      })
      window.addEventListener("orientationchange", () => {
        document.getElementById("as-searchbar").blur()
        setTimeout(() => onResize(config), 250)
      })
      onResize(config, true)
      let sortToUse = Utils.getSortFromLabel(
        config.sorts,
        config.sorts[0].label
      )
      dispatch(SetSort(sortToUse))
      let priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      if (
        config.triggers.dynamicFacetsLabels &&
        !window.AS_ADVANCED_CONFIG?.dynamicFacetsLabels
      ) {
        if (!window.AS_ADVANCED_CONFIG) window.AS_ADVANCED_CONFIG = {}
        axios
          .get(config.baseUrl + "/API/shops/" + config.shopId + "/facets")
          .then(
            (response) =>
              (window.AS_ADVANCED_CONFIG.dynamicFacetsLabels =
                response.data.facets)
          )
      }
      localStorage.setItem(
        "isSeoUrlActive",
        config.seoSettings?.isActive ?? false
      )
      setMounted(true)
      const event = new CustomEvent("as-loaded-layer")
      document.body.dispatchEvent(event)
      window.ASOpenLayer = function () {
        Utils.openLayer(
          config.display,
          config.show.type,
          window.innerWidth <= 768,
          false
        )
        const customEvent = new CustomEvent("as-open-layer")
        document.body.dispatchEvent(customEvent)
      }
      window.ASCloseLayer = function () {
        Utils.closeLayer(config.display, window.innerWidth <= 768)
        const customEvent = new CustomEvent("as-close-layer")
        document.body.dispatchEvent(customEvent)
        sessionStorage.setItem("isLayerOpen", "false")
      }

      if (
        sessionStorage.getItem("isLayerOpen") === "true" &&
        localStorage.getItem("isSeoUrlActive") === "true"
      ) {
        Utils.openLayer(
          config.display,
          config.show.type,
          window.innerWidth <= 768,
          false
        )
        const customEvent = new CustomEvent("as-open-layer")
        document.body.dispatchEvent(customEvent)
      }
    }
  }, [
    setMounted,
    mounted,
    dispatch,
    onResize,
    queryOptions,
    isMobile,
    show,
    display,
    priceGroup,
    cookies,
    ga4,
  ])

  const isCompactDisplay = useMemo(
    () => !isMobile && (display === "half-screen" || display === "windowed"),
    [display, isMobile]
  )
  const isAlertActive = useMemo(
    () =>
      (isMobile && alertConfig.mobile) ||
      (!isMobile && alertConfig.desktop && !isCompactDisplay),
    [isMobile, alertConfig, isCompactDisplay]
  )

  const isSearchwordShort = useMemo(
    () => searchWord.length < minChars,
    [searchWord, minChars]
  )
  const categoryTilesResponsive = useMemo(
    () => (isMobile ? categoryTiles.mobile : categoryTiles.desktop),
    [categoryTiles, isMobile]
  )
  const raccomandationsCategoriesResponsive = useMemo(
    () =>
      isMobile
        ? raccomandationsCategories.mobile
        : raccomandationsCategories.desktop,
    [raccomandationsCategories, isMobile]
  )

  // const noFirstScreen = useMemo(
  //   () =>
  //     (!wordsHistory || wordsHistory.length === 0) &&
  //     raccomandationsCategoriesResponsive.length === 0 &&
  //     triggers.raccomandationsProducts.length === 0 &&
  //     categoryTilesResponsive.length === 0 &&
  //     activeFilters.length === 0 &&
  //     isSearchwordShort,
  //   [
  //     triggers,
  //     activeFilters,
  //     isSearchwordShort,
  //     wordsHistory,
  //     raccomandationsCategoriesResponsive,
  //     categoryTilesResponsive,
  //   ]
  // )

  // function renderElement(){
  //   return (

  //   )
  // }

  return (
    // <Router>
    //   <Routes>
    //     <Route element={renderElement()} path={'/search?/' }/>
    //   </Routes>
    // </Router>
    <FocusScope contain restoreFocus autoFocus>
      <div
        id="accelasearch-bar-container"
        className={
          (isCompactDisplay ? display : "") +
          (isAutocompleteOpen ? " autocompleteOpen" : "") /* +
          (noFirstScreen ? " no-first-screen" : "")*/
        }
      >
        {isCompactDisplay ? (
          <div
            className="overlay"
            onClick={() => {
              sessionStorage.setItem("isLayerOpen", "false")
              Utils.closeLayer(display, isMobile)
              const customEvent = new CustomEvent("as-close-layer")
              document.body.dispatchEvent(customEvent)
            }}
          />
        ) : null}
        {!isMobile && display === "windowed" /*  && !isSearching */ ? (
          <div className="results-count">
            {" "}
            {resultsCount + " " + nameProducts}{" "}
          </div>
        ) : null}
        <div
          className={
            "search-bar-container " +
            (activeFilters.length > 0 || !isSearchwordShort
              ? "with-products"
              : "") +
            (isAlertActive ? " with-alert" : "") +
            (!!reactivePromotionsListing && !isSearchwordShort
              ? " with-promo"
              : "")
          }
        >
          {voiceSearch &&
            voiceSearch.active &&
            ((isMobile && voiceSearch.mobile) ||
              (!isMobile && voiceSearch.desktop)) && <VoiceRecognition />}

          <Header />

          {isMobile && activeFilters.length > 0 && showFilters ? (
            <div className="show-products-container">
              <div
                className="show-products"
                style={showStyle}
                onClick={hideFilters}
              >
                {" "}
                {nameShow + " " + resultsCount + " " + nameProducts}{" "}
              </div>
            </div>
          ) : null}

          {isAlertActive ? <Alert /> : null}

          {!isSearchwordShort && suggestedWords.length > 0 && !isMobile ? (
            <SuggestedWords />
          ) : null}

          {(isMobile || isCompactDisplay) &&
          !(
            products.length === 0 &&
            !isSearching &&
            !isAutocompleteOpen &&
            (activeFilters.length > 0 || !isSearchwordShort)
          ) ? (
            <FiltersButton />
          ) : null}

          {(activeFilters.length > 0 || !isSearchwordShort) &&
          !isAutocompleteOpen ? (
            <ActiveFiltersContainer />
          ) : null}

          {(activeFilters.length > 0 || !isSearchwordShort) &&
          !isAutocompleteOpen ? (
            <FiltersContainer
              subCategory={subCategory}
              setSubCategory={setSubCategory}
            />
          ) : null}

          {(activeFilters.length > 0 || !isSearchwordShort) &&
          !isAutocompleteOpen ? (
            <ResultsContainer setSubCategory={setSubCategory} />
          ) : null}
          {!isMobile && display !== "half-screen" ? (
            <Showcase />
          ) : (activeFilters.length === 0 && isSearchwordShort) ||
            isAutocompleteOpen ? (
            <Showcase />
          ) : null}
          {products.length === 0 &&
          !isSearching &&
          !isAutocompleteOpen &&
          (activeFilters.length > 0 || !isSearchwordShort) ? (
            <NoProducts />
          ) : null}
          {isMobile /* && activeFilters.length===0 && isSearchwordShort */ &&
          triggers.barcode &&
          !Utils.isChromeIos() ? (
            <BarcodeReader />
          ) : null}
          <SearchBar />
        </div>
      </div>
    </FocusScope>
  )
}

export default App
